import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import MessageHeading from '../../../components/CommonComponents/MessageHeading';
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading';
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif';
import Response_Processing from '../../../layout/Others/Response_Processing';

const ProductTypeSetting = () => {
    const access_token = localStorage.getItem('access_token');
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + access_token,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
    };

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [productType, setProductType] = useState('full_package');

    const options = [
        {
            value: 'video_library',
            title: 'Video Library',
            description: 'Show only Library Management in the admin. Hide live, audio, and other modules.'
        },
        {
            value: 'livestream',
            title: 'Livestream',
            description: 'Show only Live Stream Management in the admin. Hide video library and other modules.'
        },
        {
            value: 'playout',
            title: 'Playout',
            description: 'Show only Playout Management in the admin. Hide other modules.'
        },
        {
            value: 'full_package',
            title: 'Full Package',
            description: 'Show all modules based on role permissions (default behavior).'
        }
    ];

    useEffect(() => {
        const fetchCurrent = async () => {
            try {
                const resp = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/main-settings/get`, {
                    headers,
                    params: { fields: 'productType' },
                });
                setProductType(resp?.data?.data?.productType || 'full_package');
            } catch (e) {
                // keep default
            } finally {
                setLoading(false);
            }
        };
        fetchCurrent();
    }, []);

    const handleSave = async () => {
        try {
            setSaving(true);
            await axios.post(`${process.env.REACT_APP_Baseurl}/admin/main-settings/update`, { productType }, { headers });
            toast.success('Product type updated successfully');
            // Reload so Sidebar re-reads productType and applies menu gating
            setTimeout(() => window.location.reload(), 800);
        } catch (e) {
            toast.error(e?.response?.data?.message || 'Failed to update product type');
            setSaving(false);
        }
    };

    if (loading) return <Defaultloadinggif className="heightOnLoader" />;

    return (
        <div className="container-fluid p-0">
            <section className="p-2">
                <div className="theme-bg-color p-3 rounded-3 shadow-sm">
                    <MessageHeading className={'fs-5'} text={'Product Type'} border noMargin padding />
                    <MessageSubHeading text={'Choose which module set the admin should display.'} noMargin />

                    <div className="row mt-3">
                        {options.map((opt) => (
                            <div key={opt.value} className="col-12 col-md-4 mb-3">
                                <div className={`card h-100 ${productType === opt.value ? 'border-primary' : ''}`}>
                                    <div className="card-body">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="productType"
                                                id={`pt-${opt.value}`}
                                                value={opt.value}
                                                checked={productType === opt.value}
                                                onChange={(e) => setProductType(e.target.value)}
                                            />
                                            <label className="form-check-label fw-semibold ms-1" htmlFor={`pt-${opt.value}`}>
                                                {opt.title}
                                            </label>
                                        </div>
                                        <p className="mt-2 mb-0 small text-muted">{opt.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                            {saving ? 'Saving…' : 'Save'}
                        </button>
                    </div>
                </div>
            </section>
            {saving && <Response_Processing />}
        </div>
    );
};

export default ProductTypeSetting;
